import { render, staticRenderFns } from "./create-and-edit.vue?vue&type=template&id=02a8ed6e"
import script from "./create-and-edit.vue?vue&type=script&lang=js"
export * from "./create-and-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports